import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Standaard paginatitels op basis van route — als een pagina zelf geen title instelt, wordt deze gebruikt.
const PAGE_TITLES: Record<string, string> = {
  "/": "Online Sale Specialist | Alles voor je website. Één aanspreekpunt.",
  "/diensten": "Diensten | Online Sale Specialist",
  "/diensten/websites-bouwen": "Website bouwen | Online Sale Specialist",
  "/diensten/webshops-bouwen": "Webshop bouwen | Online Sale Specialist",
  "/diensten/seo": "SEO | Online Sale Specialist",
  "/diensten/sea": "SEA | Online Sale Specialist",
  "/diensten/hosting": "Hosting | Online Sale Specialist",
  "/diensten/wordpress-hosting": "WordPress Hosting | Online Sale Specialist",
  "/diensten/domeinnamen": "Domeinnamen | Online Sale Specialist",
  "/diensten/zakelijke-email": "Zakelijke E-mail | Online Sale Specialist",
  "/diensten/google-workspace": "Google Workspace | Online Sale Specialist",
  "/diensten/website-onderhoud": "Website Onderhoud | Online Sale Specialist",
  "/diensten/ai-optimalisatie": "AI Optimalisatie | Online Sale Specialist",
  "/over-mij": "Over Mij | Online Sale Specialist",
  "/projecten": "Projecten | Online Sale Specialist",
  "/blog": "Blog | Online Sale Specialist",
  "/nieuws": "Nieuws | Online Sale Specialist",
  "/reviews": "Reviews | Online Sale Specialist",
  "/contact": "Contact | Online Sale Specialist",
  "/offerte-aanvragen": "Offerte Aanvragen | Online Sale Specialist",
  "/kennismaking": "Kennismaking | Online Sale Specialist",
  "/online-sale-specialist-assistent": "Assistent | Online Sale Specialist",
  "/privacy": "Privacybeleid | Online Sale Specialist",
  "/voorwaarden": "Algemene Voorwaarden | Online Sale Specialist",
};

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Force an instant jump to top even if the app has global `scroll-behavior: smooth`.
    const html = document.documentElement;
    const previousInlineScrollBehavior = html.style.scrollBehavior;

    html.style.scrollBehavior = "auto";
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    // Restore after the scroll has been applied.
    window.requestAnimationFrame(() => {
      html.style.scrollBehavior = previousInlineScrollBehavior;
    });

    // Stel de paginatitel in op basis van de huidige route.
    // Pagina's die zelf een titel instellen via useEffect overschrijven dit daarna.
    const title = PAGE_TITLES[pathname];
    if (title) {
      document.title = title;
    }
  }, [pathname]);

  return null;
}
